<template>
  <div>
    <section class="container-fluid p-0 bodyArea">
      <div class="containerBox">
        <div class="pageHeader row m-0 align-items-center" v-if="$auth.isAuthenticated">
          <div class="col-3 pageHeaderTitle">Locations</div>
          <div class="col text-right p-0">
            <div class="filterWrapper" style="margin-left: 0">
              <div class="filterText">Tenant :</div>
              <div class="dropdown col p-0">
                <model-select v-model="lastSelectedTenantObj" :options="tenants" name="tenantLableName"
                  id="tenantLableId" placeholder="Select Tenant" @input="validateSelection" class="tenantsList">
                </model-select>
                <!-- <Dropdown style="background: transparent; color: #fff; border: 0" :options="tenantsList"
                  v-on:selected="validateSelection" :disabled="false" :maxItem="tenantsList.length" name="tenantDropdown"
                  class="tenantsList" placeholder="Please select a tenant">
                </Dropdown> -->
              </div>
            </div>
            <!-- <input type="file" hidden style="display: none" id="fileInput" @change="handleFiles" accept=".csv" />
            <div class="importBtn" id="csvFileInput" @click.prevent="showFileImportScreen">
              Import
            </div> -->
          </div>
        </div>
      </div>

      <div class="pageDataWrapper pageActualDataWrapper">
        <!-- <div class="userDetailContentHeader row m-0 align-items-center">
          <div class="col justify-content-end">
            <div class="subHeadWrap">{{ importLoadingMessage }}</div>
          </div>
        </div> -->
        <!-- <div class="contentHeader row m-0 align-items-center">
          <div class="col">Facility</div>
          <div class="col">Unit</div>
          <div class="col">Room</div>
          <div class="col">Facility External ID</div>
          <div class="col">Unit External ID</div>
          <div class="col">Room External ID</div>
          <div class="col">Status</div>
        </div> -->

        <div class="contentDataWrap row locationDataWrap">
          <!-- <div v-for="item in list" v-bind:key="item.id">
            <div
              class="contentDataWrapper actions contentActualDataWrapper row m-0"
            >
              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col">{{ item.facility_name }}</div>
                <div class="col">
                  {{ item.unit_name }}
                </div>
                <div class="col">{{ item.room_name }}</div>
                <div class="col">{{ item.facility_external_id }}</div>
                <div class="col">{{ item.unit_external_id }}</div>
                <div class="col">{{ item.room_external_id }}</div>
                <div class="col">{{ item.isValid }}</div>
              </div>
            </div>
          </div> -->

          <div class="col-3" style="max-width: 450px">
            <div class="filterWrapperEdit">
              <div class="">
                <div v-if="$auth.isAuthenticated" class="filterWrapper" style="margin: 0; max-width: 200px">
                  <!-- <Dropdown style="
                      background: transparent;
                      color: #fff;
                      border: 0;
                      height: auto;
                    " v-model="lastSelectedLocation" :options="locationList" v-on:selected="validateLocation"
                    :disabled="false" :maxItem="locationList.length" name="locationDropdown" placeholder="Select Location"
                    class="tenantsList locTenantWrapper">
                  </Dropdown> -->
                  <model-select v-model="lastSelectedLocation" :options="locationList" name="locationDropdown"
                    id="locationDropdownId" placeholder="Please select a location" @input="validateLocation"
                    class="tenantsList locTenantWrapper">
                  </model-select>
                </div>
              </div>
              <div class="" style="display: inline-flex; justify-content: right; gap: 10px">
                <div v-if="selectedLocationID != ''" @click.prevent="editLocation">
                  <img src="../assets/images/edit.svg" width="16" class="filterIcon" title="Edit Location" />
                </div>
                <div v-if="lastSelectedTenant != ''" @click.prevent="addLocation">
                  <img src="../assets/images/add.svg" width="16" class="filterIcon" title="Add Location" />
                </div>
              </div>
            </div>
            <ul class="leftTree">
              <TreeItem v-for="(child, index) in selectedFacility.children" :item="child" :key="child.id + index"
                :selectedFacility="selectedFacility" :selectedSamlGroup="selectedSamlGroup" :isEditable="true"
                v-on:handleClickInParent="clickEvent" />
            </ul>
          </div>
          <div v-if="itemLevel == 'FACILITY'" class="col">
            <div class="row">
              <div class="col">
                <label for="Name">Name</label>
                <input placeholder="Name" v-model="locationObject.name" class="inputText" />
              </div>

              <div class="col">
                <label for="TimeZone">Time Zone</label>
                <select placeholder="Name" v-model="locationObject.timeZoneText" class="inputSelect">
                  <option value="">Please select one</option>
                  <option v-for="option in timeZone" v-bind:key="option.id" :value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <p></p>
                <label class="checkbox-container">
                  is Active
                  <input type="checkbox" v-model="locationObject.isActive" id="cbxisActive" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <div class="col">
                <p>Available Locations</p>
                <div v-if="isUpdate == false" style="display: inline-flex; justify-content: space-evenly">
                  <label v-for="option in activeFeatures" v-bind:key="option.id" :value="option.id"
                    class="checkbox-container">
                    {{ option.name }}
                    <input type="checkbox" v-if="!updateActiveFeatures" disabled :checked="option.isEnable"
                      v-bind:id="`cbxActiveFeature${option.id}`" />
                    <input type="checkbox" v-if="updateActiveFeatures" :checked="option.isEnable"
                      v-bind:id="`cbxActiveFeature${option.id}`"
                      @change="onActiveFeaturesCheckChange(option, $event)" />

                    <span class="checkmark"></span>
                  </label>
                </div>
                <div v-if="isUpdate == true" style="display: inline-flex; justify-content: space-evenly">
                  <label v-for="option in selectedFacility.activeFeatures" v-bind:key="option.id" :value="option.id"
                    class="checkbox-container">
                    {{ option.name }}
                    <input type="checkbox" v-if="!updateActiveFeatures" disabled :checked="option.isEnable"
                      v-bind:id="`cbxActiveFeature${option.id}`" />
                    <input type="checkbox" v-if="updateActiveFeatures" :checked="option.isEnable"
                      v-bind:id="`cbxActiveFeature${option.id}`"
                      @change="onActiveFeaturesCheckChange(option, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <div class="col">
                <label class="checkbox-container">
                  Visit Manager
                  <input type="checkbox" v-model="locationObject.enableScheduling" id="cbxVisitManager" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <div class="col">
                Temperature threshold
                <input placeholder="threshhold" @keypress="isNumber($event)" maxlength="3"
                  v-model="locationObject.threshold" class="tempInput" @change="onTempChange($event)" />
                ( temperature should between 90 °F and 107 °F )
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <div class="col externalIdClass">
                External Identifier Ids (Press Enter and hit Update)
                <b-form-tags
                  v-model="tags"
                  tag-variant="primary"
                  placeholder="Add Id"
                  tag-class="tagsInput"
                  remove-on-delete
                />
              </div>
              <div class="col">
                <label for="mobileHeartBeatUrl">MobileHeartbeat URL</label>
                <input class="tempInput" style="width: 100%" placeholder="URL"
                  v-model="locationObject.mobileHeartbeatURL" />
              </div>
              <div class="col">
                <label for="TimeZone">VRN Name Format</label>
                <select placeholder="Name" v-model="locationObject.callerIdNameFormat" class="inputSelect">
                  <option value="">Please select one</option>
                  <option v-for="option in callerIdNameFormatOptions" v-bind:key="option.id" :value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="areaLogo"> Virtual Background ImageURL</label>
                <button class="btn btn-primary" @click.prevent="showVirtualBackgroundModal($event)">
                  {{ virtualBackground.buttonText }}
                </button>
              </div>
              <div class="col">
                <label for="areaLogo">Redirect Participant To URL</label>
                <input class="tempInput" style="width: 100%" placeholder="URL"
                  v-model="locationObject.redirectParticipantToURL" />
              </div>
              <div class="col">
                <label for="areaLogo"> Device Facility Logo</label>
                <input class="tempInput" style="width: 100%" placeholder="Logo"
                  v-model="locationObject.deviceFacilityLogo" />
              </div>
              <div class="col" style="margin-top: 19px">
                <p></p>
                <label class="checkbox-container">
                  Integration Not Available
                  <input type="checkbox" v-model="locationObject.integrationNotAvailable" id="cbxisActive" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <button class="importBtn" :disabled="!isLocationValid()" @click.prevent="saveLocation">
                {{ isUpdate == true ? "Update" : "Save" }}
              </button>
            </div>
          </div>
          <div v-if="itemLevel == 'UNIT'" class="col">
            <div class="row">
              <div class="col">
                <label for="Name">Name</label>
                <input placeholder="Name" v-model="unitObject.name" class="tempInput" />
              </div>
              <div class="col">
                <p></p>
                <label class="checkbox-container">
                  is Active
                  <input type="checkbox" v-model="unitObject.isActive" id="cbxisActive" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <div class="col externalIdClass">
                External Identifier Ids (Press Enter and hit Update)
                <b-form-tags
                  v-model="tags"
                  tag-variant="primary"
                  placeholder="Add Id"
                  tag-class="tagsInput"
                  class="w-50"
                  remove-on-delete
                />
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <button class="importBtn" :disabled="!isUnitValid()" @click.prevent="saveUnit">
                {{ isUnitUpdate == true ? "Update" : "Save" }}
              </button>
            </div>
          </div>
          <div v-if="itemLevel == 'AREA'" class="col">
            <div class="row">
              <div class="col">
                <label for="Name">AMS Zone Name</label>
                <input placeholder="Name" v-model="areaObject.name" />
              </div>
              <div class="col">
                <label for="Name">AMS Zone Type</label>
                <select placeholder="Name" v-model="areaObject.type">
                  <option value="">Please select one</option>
                  <option v-for="option in roomDefaultTypes" v-bind:key="option.id" :value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p></p>
                <label class="checkbox-container">
                  Maintenance Mode
                  <input type="checkbox" v-model="areaObject.maintenanceMode" id="cbxisActive" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="col">
                <p></p>
                <label class="checkbox-container">
                  Allow Orphaned Tasks
                  <input type="checkbox" v-model="areaObject.allowOrphanedTasks" id="cbxisActive" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="col">
                <label for="areaLogo"> Device Area Logo</label>
                <input style="width: 100%" placeholder="Device Area Logo" v-model="areaObject.deviceAreaLogo" />
              </div>
              <div class="col">
                <p></p>
                <label class="checkbox-container">
                  Show Rounding Task
                  <input type="checkbox" v-model="areaObject.showRoundingTask" id="cbxisActive" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label for="Name">TV Config</label>
                <select placeholder="Name" @change="onMappingChanged($event, areaObject)"
                  v-model="areaObject.allowed_tv_config">
                  <option value="">Select TV Config</option>
                  <option v-for="option in tvConfigs" v-bind:key="option.code" :value="option.code">
                    {{ option.name }}
                  </option>

                </select>
              </div>
              <!-- <div class="col-2">
                <p></p>
                <label class="checkbox-container">
                  Is External Id
                  <input type="checkbox" v-model="areaObject.hasExternalID" id="cbxisExtrnalID" />
                  <span class="checkmark"></span>
                </label>
              </div> -->
              <div class="col-3">
                <label for="areaLogo">Tv External Id</label>
                <input style="width: 100%" :disabled="!areaObject.hasExternalID" placeholder="External Id"
                  v-model="areaObject.tvExternalID" />
              </div>
              <div class="col">
                <label for="areaLogo"> Bedside Phone</label>
                <input style="width: 100%" v-bind:class="{'inputError': !validatePhoneNumberExtension(areaObject.bedsidePhone)}"  placeholder="Bedside Phone" v-model="areaObject.bedsidePhone" />
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <div class="col externalIdClass">
                External Identifier Ids (Press Enter and hit Update)
                <b-form-tags
                  v-model="tags"
                  tag-variant="primary"
                  placeholder="Add Id"
                  tag-class="tagsInput"
                  class="w-50"
                  remove-on-delete
                />
                <!-- <vue-tags-input placeholder="Add Id" v-model="tag" :tags="tags" :validation="validation"
                  @tags-changed="(newTags) => (tags = newTags)" /> -->
              </div>
            </div>
            <div class="row" style="padding: 15px 0">
              <button class="importBtn" :disabled="!isAreaValid()" @click.prevent="saveArea">
                {{ isAreaUpdate == true ? "Update" : "Save" }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="listEmpty == true">
          <h3>No results found</h3>
        </div>
      </div>

      <b-modal v-model="virtualBackgroundModal" hide-backdrop id="virtualBackground" centered
        v-bind:title="virtualBackground.title" ok-title="Ok" @ok="updateVirtualBackgroundClick($event)"
        @cancel="virtualBackgroundModal = false" ok-title-html="Upload">
        <h6>{{ virtualBackground.popupTextHeader }}</h6>
        <div class="virtualBackgroundDIV">
          <img class="virtualBackGroundImage" v-if="virtualBackground.virtualBackgroundCORSEnablePath"
            v-bind:src="virtualBackground.virtualBackgroundCORSEnablePath">
          <img class="virtualBackGroundImage" v-if="!virtualBackground.virtualBackgroundCORSEnablePath"
            src="../assets/images/cai_bg_fractal_dots2.png" style="margin-left:8px" />
        </div>
        <div class="virtualBackgroundUploadDIV">
          <h6>Click upload to add/update the file.</h6>
          <h6 style="color: #f16161; ">Note: Allowed Images are JPG or PNG only and the resolution should be 1920x1080
          </h6>
          <button class="btn btn-primary" @click.prevent="clickEventToUploadBackground($event)">Select file to
            upload</button>
          <input type="file" hidden style="display: none" id="fileInput" @change="fileSelectedForUploadEvent"
            accept=".jpg,.png" />
        </div>
      </b-modal>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
import ReleaseNavBar from "../components/ReleaseNavBar.vue";
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Dropdown from "vue-simple-search-dropdown";
import { tr } from "date-fns/locale";
import TreeItem from "../components/TreeEditItem.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import VueTagsInput from "@johmun/vue-tags-input";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

Vue.use(VueToast);
Vue.use(Loading);
export default {
  name: "Locations",
  components: {
    ReleaseNavBar,
    Datepicker,
    Dropdown,
    TreeItem,
    VueTagsInput,
    ModelSelect
  },
  props: {
    selectedSamlGroup: {}
  },
  data() {
    return {
      list: "",
      tenantsList: [],
      tvConfigs: [],
      value: "",
      dateValue: "",
      selectedFacility: {},
      lastSelectedTenant: "",
      lastSelectedTenantObj: "",
      selectedLocationID: "",
      tenants: [{ text: "-SELECT ALL-", value: "*" }],
      lastSelectedLocation: "",
      listEmpty: false,
      importLoadingMessage: "",
      locationList: [],
      customerList: [],
      errorMessage: "",
      updateActiveFeatures: false,
      virtualBackgroundModal: false,
      virtualBackground: {
        title: "Virtual Background",
        buttonText: "Add/Update Virtual Background",
        locationId: "",
        virtualBackgroundImageUrl: "",
        virtualBackgroundCORSEnablePath: "",
        popupTextHeader: "Facility does not have any file available on-file",
        data: {}
      },
      timeZone: [
        {
          id: "ET", // timeZone
          name: "Eastern Time",
          city: "America/New_York" // timezoneWithCity
        },
        {
          id: "CT",
          name: "Central Time",
          city: "America/Chicago"
        },
        {
          id: "MT",
          name: "Mountain Time",
          city: "America/Denver"
        },
        {
          id: "MST",
          name: "Mountain Time - Arizona",
          city: "America/Phoenix"
        },
        {
          id: "PT",
          name: "Pacific Time",
          city: "America/Los_Angeles"
        },
        {
          id: "AKDT",
          name: "Alaska Time",
          city: "US/Alaska"
        },
        {
          id: "HAST",
          name: "Hawaii Time",
          city: "US/Hawaii"
        }
      ],
      callerIdNameFormatOptions: [
        { id: "HIDE_LAST_NAME", name: "Hide Last Name" },
        { id: "HIDE_FIRST_NAME", name: "Hide First Name" }],
      activeFeatures: [
        {
          id: "1",
          name: "Patient Rooms",
          isExpanded: true,
          type: "location",
          typeFilter: "AREAS_ROOM",
          isEnable: false,
          image: "icon-room",
          children: []
        },
        {
          id: "2",
          name: "Hallway Locations",
          type: "hallway",
          typeFilter: "AREAS_HALLWAY",
          isEnable: false,
          image: "icon-hallway",
          children: []
        },
        {
          id: "3",
          name: "Entrances",
          type: "location",
          typeFilter: "AREAS_ENTRANCE",
          isEnable: true,
          image: "icon-entrance",
          children: [],
          temperature: 100.0,
          isActive: true
        },
        {
          id: "4",
          name: "Handwash Locations",
          type: "location",
          typeFilter: "AREAS_HANDWASH",
          isEnable: false,
          image: "icon-handwash",
          children: []
        },
        {
          id: "5",
          name: "Patient Homes",
          type: "location",
          typeFilter: "ROOM_MONITORING",
          isEnable: false,
          image: "icon-home-user",
          children: []
        },
        {
          id: "6",
          name: "Nurse Station",
          type: "location",
          typeFilter: "AREAS_NURSE_CALL_STATION",
          isEnable: false,
          image: "icon-nurse-rounding",
          children: []
        }
      ],
      isUpdate: false,
      isUnitUpdate: false,
      isAreaUpdate: false,
      itemLevel: "",
      tag: "",
      tags: [],
      inputValid: true,
      validation: [
        {
          classes: "min-length",
          rule: (tag) => {
            // const cleanedValue = tag.text.replace(/[^A-Za-z0-9_]/g, "");
            // this.inputValid = cleanedValue === tag.text;
            // return this.inputValid;
            return false;
          }
        }
      ],
      locationObject: {
        id: "",
        name: "",
        isActive: true,
        enableScheduling: false,
        timeZoneText: "",
        unitMeasurements: {
          temperature: "F",
          dateFormat: "MM/DD/YYYY hh:mm tt"
        },
        threshold: "100",
        virtualBackgroundImageUrl: "",
        redirectParticipantToURL: "",
        deviceFacilityLogo: "",
        integrationNotAvailable: false,
        callerIdNameFormat: "",
        mobileHeartbeatURL:""
      },
      unitObject: {
        id: "",
        name: "",
        isActive: true
      },
      areaObject: {
        id: "",
        name: "",
        type: "Ambient Monitoring",
        maintenanceMode: false,
        allowOrphanedTasks: false,
        showRoundingTask: false,
        allowed_tv_config: "",
        deviceAreaLogo: "",
        typeFilter: "",
        unitId: "",
        externalIDs: "",
        tvExternalID: "",
        hasExternalID: false,
        bedsidePhone: ""
      },
      roomDefaultTypes: [
        {
          id: "Ambient Monitoring",
          name: "Ambient Monitoring"
        },
        {
          id: "Video Call",
          name: "Video Call"
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
    $("input").attr("autocomplete", "off");
  },
  async created() {
    setTimeout(
      function () {
        this.fetchTenants();
        this.updateActiveFeaturesFlag();
      }.bind(this),
      1000
    );
  },
  methods: {
    onDateChange() {
      this.dateValue = this.value.format("YYYY-MM-DD");
    },
    externalPattern() {
      if (this.tags.length) {
        this.tags.forEach((value) => {
          const cleanedValue = (value || "").toString().replace(/[^A-Za-z0-9_\"\'`]/g, "");
          if (cleanedValue !== value) this.inputValid = false;
        });
      }
    },
    cleanInputValue() {
      const cleanedValue = this.inputValue.replace(/[^a-zA-Z0-9]/g, "");
      this.inputValid = cleanedValue === this.inputValue;
      return cleanedValue;
    },
    async onMappingChanged(event, mappingObj) {
      let tvConfig = this.tvConfigs.find(e => e.code == event.target.value);
      if (tvConfig && tvConfig.isExternalIdRequired === true) {
        this.areaObject.hasExternalID = true;
      } else {
        this.areaObject.hasExternalID = false;
      }
    },
    async showVirtualBackgroundModal() {
      this.assignVirtualBackgroundProps();
      this.$bvModal.show("virtualBackground");
    },
    async updateVirtualBackgroundClick(bvModalEvent) {
      bvModalEvent.preventDefault();

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;

      const digitalBackgroundURL = `${config.DIGITAL_WHITEBOARD}/tenants/${this.lastSelectedTenant}/locations/${this.virtualBackground.locationId}/virtual-background`;
      const postRequest = new Request(digitalBackgroundURL, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: this.virtualBackground.data,
        headers: {
          Authorization: "Bearer " + id_token
        }
      });
      try {
        var digitalWhiteBoardPatchResponse = await fetch(postRequest);
        // console.log("updateVirtualBackgroundClick", digitalWhiteBoardPatchResponse, await digitalWhiteBoardPatchResponse.json());
        if (digitalWhiteBoardPatchResponse.status === 403)
          Vue.$toast.open({ message: "Do not have permission to upload the Virtual Background. Please check with Administrator.", type: "error" });
        else if (digitalWhiteBoardPatchResponse.status === 401)
          Vue.$toast.open({ message: "Your session has expired please login again to continue.", type: "error" });
        else if (digitalWhiteBoardPatchResponse.status === 503)
          return this.updateVirtualBackgroundClick();

        if (digitalWhiteBoardPatchResponse.status !== 200) {
          const responseError = await digitalWhiteBoardPatchResponse.json();
          if (responseError && responseError.error) {
            const errorMessageSplit = responseError.error.split(":");
            if (errorMessageSplit.length > 0) {
              Vue.$toast.open({ message: errorMessageSplit[errorMessageSplit.length - 1], type: "error" });
            }
          } else Vue.$toast.open({ message: "Failed to upload virtual background for the Facility", type: "error" });
        } else {
          const responseObject = await digitalWhiteBoardPatchResponse.json();
          this.locationObject.virtualBackgroundImageUrl = responseObject.virtualBackground;
          if (this.locationList && this.locationList.length > 0) {
            let location = this.locationList.find(l => l.locationId === this.virtualBackground.locationId);
            if (location && location.settings && location.settings.virtualBackgroundImageUrl) {
              location.settings.virtualBackgroundImageUrl = responseObject.virtualBackground;
            } else {
              location["settings"]["virtualBackgroundImageUrl"] = responseObject.virtualBackground;
            }
          }

          Vue.$toast.open({ message: "Virtual background is uploaded successfully.", type: "success" });
          this.$bvModal.hide("virtualBackground");
        }
      } catch (err) {
        Vue.$toast.open({ message: "Failed to upload virtual background for the Facility", type: "error" });
      }
    },
    async clickEventToUploadBackground() {
      document.getElementById("fileInput").click();
    },
    defaultPropsForVirtualBackground() {
      this.virtualBackground = {
        title: "Virtual Background",
        buttonText: "Add/Update Virtual Background",
        locationId: "",
        virtualBackgroundImageUrl: "",
        virtualBackgroundCORSEnablePath: "",
        popupTextHeader: "Facility does not have any virtual-background set. Below is the default background available.",
        data: {}
      };
    },
    assignVirtualBackgroundProps() {
      this.defaultPropsForVirtualBackground();
      this.virtualBackground.locationId = this.locationObject.id;
      this.virtualBackground.virtualBackgroundImageUrl = this.locationObject.virtualBackgroundImageUrl;

      if (this.virtualBackground.virtualBackgroundImageUrl) {
        this.virtualBackground.title = "Virtual Background - " + this.locationObject.name;
        this.virtualBackground.buttonText = "View/Update - Virtual background";
        this.virtualBackground.popupTextHeader = "Saved image on-file for - " + this.locationObject.name;

        let imageType = "jpg";
        const virtualBackgroundPath = this.virtualBackground.virtualBackgroundImageUrl.split("/");
        if (virtualBackgroundPath && virtualBackgroundPath.length > 0) {
          const imageFileName = virtualBackgroundPath[virtualBackgroundPath.length - 1];
          if (imageFileName) {
            const imageFileNameExt = imageFileName.split(".");
            if (imageFileNameExt && imageFileNameExt.length > 0) {
              imageType = imageFileNameExt[imageFileNameExt.length - 1];
            }
          }
        }

        if (this.virtualBackground.virtualBackgroundImageUrl.indexOf("gs://") !== -1) {
          this.virtualBackground.virtualBackgroundCORSEnablePath = `${config.DIGITAL_WHITEBOARD}/tenants/${this.lastSelectedTenant}/locations/${this.locationObject.id}/virtual-background/${imageType}`;
        }
      } else {
        this.virtualBackground.title = "Virtual Background - " + this.locationObject.name;
        this.virtualBackground.buttonText = "Add - Virtual background";
      }
    },
    async fileSelectedForUploadEvent(event) {
      if (event && event.target && event.target.files) {
        if (event.target.files.length > 1) {
          Vue.$toast.open({ message: "More than 1 file selected for upload", type: "error" });
          return;
        }

        if (event.target.files.length > 0) {
          const backgrounImage = event.target.files[0];
          const fileReader = new FileReader();
          fileReader.readAsDataURL(backgrounImage);
          fileReader.onload = (evt) => {
            this.virtualBackground.virtualBackgroundCORSEnablePath = evt.target.result;
          };

          let data = new FormData();
          data.append("file", event.target.files[0]);

          this.virtualBackground.data = data;
          this.virtualBackground.popupTextHeader = "Click upload to save the file for Facility";
        }
      } else {
        Vue.$toast.open({ message: "No file selected for upload", type: "error" });
        return;
      }
    },
    async clickEvent(data) {
      this.tag = "";
      this.tags = [];
      // alert(data.level + " ---" + data.actionCommand);
      if (
        data.level == "ACTIVEFEATURE" ||
        (data.level == "UNIT" && data.actionCommand == "EDIT")
      ) {
        this.itemLevel = "UNIT";
        if (data.actionCommand == "EDIT") {
          this.isUnitUpdate = true;
          this.unitObject = {
            id: data.unitId,
            name: data.name,
            isActive: true
          };
         this.assignTags(data);
        } else {
          this.isUnitUpdate = false;
          this.unitObject = {
            id: "",
            name: "",
            isActive: true
          };
        }
      } else if (
        (data.level == "UNIT" && data.actionCommand == "ADD") ||
        (data.level == "AREA" && data.actionCommand == "EDIT")
      ) {
        this.itemLevel = "AREA";
        if (data.actionCommand == "ADD") {
          this.isAreaUpdate = false;
          this.areaObject = {
            id: "",
            name: "",
            type: "Ambient Monitoring",
            maintenanceMode: false,
            allowOrphanedTasks: false,
            typeFilter: data.typeFilter ? data.typeFilter : "",
            unitId: data.unitId,
            allowed_tv_config: "",
            deviceAreaLogo: "",
            showRoundingTask: "",
            externalIDs: "",
            tvExternalID: "",
            bedsidePhone: "",
            hasExternalID: false

          };
        } else {
          this.isAreaUpdate = true;
          this.areaObject = {
            id: data.areaId,
            name: data.name,
            type: data.defaultRoomView ? data.defaultRoomView : "",
            typeFilter: data.typeFilter ? data.typeFilter : "",
            unitId: data.unitId,
            maintenanceMode:
              data.settings && data.settings.isInMaintenance
                ? data.settings.isInMaintenance
                : false,
            allowOrphanedTasks:
              data.settings && data.settings.allowOrphanedTasks
                ? data.settings.allowOrphanedTasks
                : false,
            deviceAreaLogo:
              data.settings && data.settings.deviceAreaLogo
                ? data.settings.deviceAreaLogo
                : "",
            bedsidePhone:
              data.settings && data.settings.bedsidePhone
                ? data.settings.bedsidePhone
                : "",
            allowed_tv_config: "",
            externalIDs: "",
            tvExternalID: "",
            hasExternalID: false,
            showRoundingTask:
              data.settings && data.settings.showRoundingTask
                ? data.settings.showRoundingTask
                : ""
          };


          let poc = {
            location: this.lastSelectedLocation,
            unit: data.unitId,
            area: data.areaId,
            model: "AMS R2O",
            typeFilter: data.typeFilter
          };
          let res = await this.getPointOfCareProperties(poc);
          if (res && res.length > 0) {
            const tvSettingObj = res.find(r => r.key === "tv_settings");
            if (tvSettingObj && tvSettingObj.value) {
              const tvSetting = tvSettingObj.value.type;
              const tvSettingExternalId = tvSettingObj.value.tvSettingExternalId;
              let tvConfig = this.tvConfigs.find(e => e.code == tvSetting);
              if (poc.typeFilter === "AREAS_ROOM") {
                this.areaObject = {
                  id: data.areaId,
                  name: data.name,
                  type: data.defaultRoomView ? data.defaultRoomView : "",
                  typeFilter: data.typeFilter ? data.typeFilter : "",
                  unitId: data.unitId,
                  maintenanceMode:
                    data.settings && data.settings.isInMaintenance
                      ? data.settings.isInMaintenance
                      : false,
                  allowOrphanedTasks:
                    data.settings && data.settings.allowOrphanedTasks
                      ? data.settings.allowOrphanedTasks
                      : false,
                  deviceAreaLogo:
                    data.settings && data.settings.deviceAreaLogo
                      ? data.settings.deviceAreaLogo
                      : "",
                  deviceVol:
                    data.settings && data.settings.device_maxvol
                      ? data.settings.device_maxvol
                      : 100,
                  bedsidePhone:
                    data.settings && data.settings.bedsidePhone
                      ? data.settings.bedsidePhone
                      : "",
                  allowed_tv_config: tvConfig ? tvConfig.code : "",
                  externalIDs: "",
                  tvExternalID: tvSettingExternalId ? tvSettingExternalId : "",
                  hasExternalID: tvConfig && tvConfig.isExternalIdRequired === true ? true : false,
                  showRoundingTask:
                    data.settings && data.settings.showRoundingTask
                      ? data.settings.showRoundingTask
                      : ""
                };
                // this.areaObject.allowed_tv_config = tvConfig ? tvConfig.code : '';
                // this.areaObject.externalIDs = externalId ? externalId : ''
                // if (tvConfig) {
                //   this.areaObject.hasExternalID = true
                // }
              }
            }
          } else {
            this.areaObject = {
              id: data.areaId,
              name: data.name,
              type: data.defaultRoomView ? data.defaultRoomView : "",
              typeFilter: data.typeFilter ? data.typeFilter : "",
              unitId: data.unitId,
              maintenanceMode:
                data.settings && data.settings.isInMaintenance
                  ? data.settings.isInMaintenance
                  : false,
              allowOrphanedTasks:
                data.settings && data.settings.allowOrphanedTasks
                  ? data.settings.allowOrphanedTasks
                  : false,
              deviceAreaLogo:
                data.settings && data.settings.deviceAreaLogo
                  ? data.settings.deviceAreaLogo
                  : "",
              bedsidePhone:
                data.settings && data.settings.bedsidePhone
                  ? data.settings.bedsidePhone
                  : "",
              allowed_tv_config: "",
              externalIDs: "",
              tvExternalID: "",
              hasExternalID: false,
              showRoundingTask:
                data.settings && data.settings.showRoundingTask
                  ? data.settings.showRoundingTask
                  : ""
            };
          }
          this.assignTags(data);
        }
      } else {
        this.itemLevel = "FACILITY";
      }
    },
    async fetchTenants() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );

      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status == 503) {
          return this.fetchTenants();
        }
        var response = await tenants_list.json();
        this.tenants = response
          .map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace("-", "")
            };
          })
          .sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
        this.tenants.forEach((e) =>
          this.tenantsList.push({ id: e.value, name: e.text })
        );
        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();
      }
    },
    async getTVConfigs() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.SENSOR_SERVICE +
        `/tenants/${this.lastSelectedTenant}/settings/tv`,
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );

      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status == 503) {
          return this.getTVConfigs();
        }
        var response = await tenants_list.json();
        this.tvConfigs = response;
        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();
      }
    },
    async getPointOfCareProperties(poc) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      let query = "?";
      if (poc.model) {
        query = query + "model=" + poc.model;
      }
      var pointOfCareProperties_request = new Request(
        config.API_GATEWAY + `/tenants/${this.lastSelectedTenant}/locations/${poc.location}/units/${poc.unit}/areas/${poc.area}/pointOfCareProperties${query}`,
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );

      try {
        var poc_list = await fetch(pointOfCareProperties_request);
        if (poc_list.status == 503) {
          return this.getPointOfCareProperties(poc);
        }
        var res = await poc_list.json();
        loader.hide();
        return res;

      } catch (error) {
        console.error("Failed to get point-of-care-properties", error);
        loader.hide();
      }
    },
    async updatePointOfCareProperties(poc, body, feature = "virtual-monitoring") {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      let query = "?";
      if (feature) {
        query += `feature=${feature}`;
      }
      var pointOfCareProperties_request = new Request(
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/${poc.location}/units/${poc.unit}/areas/${poc.area}/pointOfCareProperties${query}`,
        {
          method: "PATCH",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          body: JSON.stringify(body),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );

      try {
        var poc_list = await fetch(pointOfCareProperties_request);
        if (poc_list.status == 503) {
          return this.updatePointOfCareProperties(poc);
        }
        var res = await poc_list.json();


      } catch (error) {
        console.error(error);

      }
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id;
      } else {
        return "";
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.itemLevel = "";
      this.locationList = [];
      this.selectedLocationID = "";
      this.selectedFacility = {};
      this.changeTenantView();
      this.getTVConfigs();
    },
    validateLocation() {
      this.itemLevel = "FACILITY";
      let selFaclility = this.locationList.find(e => e.locationId === this.lastSelectedLocation);
      if (selFaclility)
        this.selectedFacility = selFaclility;
      this.selectedLocationID = this.lastSelectedLocation;
      this.changeLocationView();
    },
    async changeTenantView() {
      this.locationList = [];
      await this.getLocations();
    },
    assignTagsLocation(data) {
      this.tags = [];
      this.tag = "";
      if (data && data.externalIds && data.externalIds.length) {
        data.externalIds.forEach((e) => {
          this.tags.push( e.externalId);
        });
      }
    },
    assignTags(data){
      this.tags = [];
      this.tag = "";
      if (data && data.externalIds && data.externalIds.length) {
        data.externalIds.forEach((e) => {
          this.tags.push(e);
        });
      }
    },
    async changeLocationView() {
      this.isUpdate = true;
      this.locationObject.id = this.selectedFacility.locationId;
      this.locationObject.name = this.selectedFacility.name;
      this.locationObject.enableScheduling =
        this.selectedFacility.enableScheduling;
      this.locationObject.isActive = this.selectedFacility.isActive;
      this.locationObject.locationId = this.selectedFacility.locationId;
      this.locationObject.timeZoneText = this.selectedFacility.timezone;
      this.locationObject.virtualBackgroundImageUrl =
        this.selectedFacility.settings &&
          this.selectedFacility.settings.virtualBackgroundImageUrl
          ? this.selectedFacility.settings.virtualBackgroundImageUrl
          : "";
      this.locationObject.integrationNotAvailable =
        this.selectedFacility.settings &&
          this.selectedFacility.settings.integrationNotAvailable
          ? this.selectedFacility.settings.integrationNotAvailable
          : "";
      this.locationObject.redirectParticipantToURL =
        this.selectedFacility.settings &&
          this.selectedFacility.settings.redirectParticipantToURL
          ? this.selectedFacility.settings.redirectParticipantToURL
          : "";
      this.locationObject.deviceFacilityLogo =
        this.selectedFacility.settings &&
          this.selectedFacility.settings.deviceFacilityLogo
          ? this.selectedFacility.settings.deviceFacilityLogo
          : "";
      this.locationObject.callerIdNameFormat =
        this.selectedFacility.settings &&
          this.selectedFacility.settings.callerIdNameFormat
          ? this.selectedFacility.settings.callerIdNameFormat
          : "";
      this.locationObject.mobileHeartbeatURL =
      this.selectedFacility.settings &&
          this.selectedFacility.settings.mobileHeartbeatURL
          ? this.selectedFacility.settings.mobileHeartbeatURL
          : "";
      var sTimeZone = this.timeZone.filter(
        (e) => e.id == this.selectedFacility.timezone
      )[0];
      if (sTimeZone) {
        this.locationObject["timezone"] = sTimeZone.id;
        this.locationObject["timezoneWithCity"] = sTimeZone.city;
      }
      this.locationObject.threshold = this.selectedFacility.activeFeatures.find(
        (e) => e.typeFilter == "AREAS_ENTRANCE"
      )
        ? this.selectedFacility.activeFeatures.find(
          (e) => e.typeFilter == "AREAS_ENTRANCE"
        ).temperature
        : "0";
      this.assignTagsLocation(this.selectedFacility);

      // this.locationList = [];
      // await this.getLocations();
    },
    editLocation() {
      this.itemLevel = "FACILITY";
      this.changeLocationView();
    },
    addLocation() {
      this.itemLevel = "FACILITY";
      this.isUpdate = false;
      this.tag = "";
      this.tags = [];
      this.locationObject = {
        id: "",
        name: "",
        isActive: true,
        enableScheduling: false,
        timeZoneText: "",
        unitMeasurements: {
          temperature: "F",
          dateFormat: "MM/DD/YYYY hh:mm tt"
        },
        threshold: "100",
        virtualBackgroundImageUrl: "",
        integrationNotAvailable: false,
        redirectParticipantToURL: "",
        deviceFacilityLogo: "",
        callerIdNameFormat: "",
        mobileHeartbeatURL: ""
      };
    },
    async fetchData() {
      this.listEmpty = false;
      this.list = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
    },
    async getLocations() {
      this.locationList = [];
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/incomplete-taxonomy`;
      var get_Location = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.getLocations();
        }
        var getLoc = await response.json();
        getLoc = this.sortArrayByKey(getLoc, "name");
        getLoc.forEach(e => {
          e.text = e.name;
          e.value = e.locationId;
        });
        this.locationList = getLoc;
        this.buildTreeControlMapping(this.locationList);
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    buildTreeControlMapping(locations) {
      let locList = [];
      if (locations && locations.length > 0) {
        locations.forEach((location) => {
          let locationChildren = {
            id: location.locationId,
            locationId: location.locationId,
            activeFeatures: location.activeFeatures,
            uniqueId: location.locationId,
            isActive: location.isActive,
            enableScheduling: location.enableScheduling,
            timezone: location.timezone,
            timezoneWithCity: location.timezoneWithCity,
            externalIds: location.externalIds,
            name: location.name,
            unitMeasurements: location.unitMeasurements,
            level: "LOCATION",
            children: [],
            units: location.units,
            settings: location.settings,
            text: location.name,
            value: location.locationId
          };
          if (location.activeFeatures && location.activeFeatures.length > 0) {
            location.activeFeatures.forEach((activeFeature) => {
              let activeFeatureChild = {
                id: activeFeature.id + "_" + location.locationId,
                uniqueId: location.locationId,
                locationId: location.locationId,
                id: location.locationId,
                name: activeFeature.name,
                type: activeFeature.type,
                level: "ACTIVEFEATURE",
                typeFilter: activeFeature.typeFilter,
                children: []
              };
              if (location.units && location.units.length > 0) {
                location.units.forEach((unit) => {
                  let unitChild = {
                    id: activeFeature.id + "_" + unit.id,
                    uniqueId: unit.id,
                    locationId: location.locationId,
                    unitId: unit.id,
                    name: unit.name,
                    isActive: unit.isActive,
                    level: "UNIT",
                    typeFilter: activeFeature.typeFilter,
                    externalIds: unit.externalIds,
                    children: [],
                    area: unit.areas,
                    isOpen: unit.isOpen ? unit.isOpen : false
                  };
                  if (unit.areas && unit.areas.length > 0) {
                    let activeAreas = unit.areas.filter(
                      (a) => a.type === activeFeature.typeFilter
                    );
                    activeAreas = this.sortArrayByKey(activeAreas, "name");

                    activeAreas.forEach((area) => {
                      locationChildren.roomCount++;
                      const areaChild = {
                        id: area.id,
                        uniqueId: area.id,
                        locationId: location.locationId,
                        unitId: unit.id,
                        areaId: area.id,
                        name: area.name,
                        level: "AREA",
                        defaultRoomView: area.defaultRoomView,
                        settings: area.settings,
                        typeFilter: area.type || area.typeFilter,
                        externalIds: area.externalIds
                      };
                      unitChild.children.push(areaChild);
                    });
                  }
                  // if (
                  //   unitChild &&
                  //   unitChild.children &&
                  //   unitChild.children.length > 0
                  // )
                  activeFeatureChild.children.push(unitChild);
                });
              }
              // if (
              //   activeFeatureChild &&
              //   activeFeatureChild.children &&
              //   activeFeatureChild.children.length > 0
              // )
              locationChildren.children.push(activeFeatureChild);
            });
          }
          // if (
          //   locationChildren &&
          //   locationChildren.children &&
          //   locationChildren.children.length > 0
          // )
          locList.push(locationChildren);
        });
      }
      this.locationList = locList;
    },
    sortArrayByKey(array, key) {
      if (array.length > 0) {
        return array.sort((a, b) => {
          try {
            const x = a[key].toLowerCase();
            const y = b[key].toLowerCase();
            return x < y ? -1 : x > y ? 1 : 0;
          } catch (err) {
          }
          return -1;
        });
      } else {
        return array;
      }
    },
    async showFileImportScreen() {
      //var connections = await this.getConnections();
      document.getElementById("fileInput").click();
    },
    isImportedLocationValid(loc) {
      var userLoc = this.locationList.find(
        (x) => x.name.toLowerCase() === loc.facility_name.toLowerCase()
      );
      if (userLoc) {
        var units = userLoc.units.find(
          (x) => x.name.toLowerCase() === loc.unit_name.toLowerCase()
        );
        if (units) {
          var areas = units.areas.find(
            (x) => x.name.toLowerCase() === loc.room_name.toLowerCase()
          );
          if (areas) {
            return "Ready to Import";
          } else {
            return "Room Not found";
          }
        } else {
          return "Unit Not found";
        }
      } else return "Faciltiy Not found";
    },
    handleFiles(event) {
      this.importLoadingMessage = "Loading file: " + event.target.files[0];
      if (window.FileReader) {
        this.list = [];
        var fileToRead = event.target.files[0];
        var reader = new FileReader();
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          var csv = event.target.result;
          var allTextLines = csv.split(/\r\n|\n/);
          var lines = [];
          var headers = this.CSVtoArray(allTextLines.shift());
          this.importLoadingMessage = "Validating Headers";
          if (!this.validateHeaders(headers)) {
            this.importLoadingMessage =
              "Validation Failed! Missing: " + this.importLoadingMessage;

            return false;
          }
          this.importLoadingMessage = "Loading Users";
          var listOfUsers = [];
          while (allTextLines.length - 1) {
            listOfUsers.push(
              this.csvArrayToJSON(
                headers,
                this.CSVtoArray(allTextLines.shift())
              )
            );
          }
          var lineNumber = 0;
          if (listOfUsers.length > 0) {
            listOfUsers.forEach((u) => {
              if (!u) {
                u = {};
              }
              ++lineNumber;
              u.lineNumber = lineNumber;
              for (var key in u) {
                if (u[key] && typeof u[key] === "string") {
                  u[key] = u[key].trim();
                }
              }
              u.isValid = this.isImportedLocationValid(u);
              this.list.push(u);
            });
            this.importLoadingMessage = "Loaded Locations: " + this.list.length;
          } else {
            this.importLoadingMessage = "No users defined";
          }
        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        this.importLoadingMessage = "Cannot read file";
      }
    },
    validateHeaders(headers) {
      if (headers && Array.isArray(headers) && headers.length >= 8) {
        var errMsg = "";
        if (!headers.includes("facility_name")) {
          errMsg += "\r\n- Facility";
        }
        if (!headers.includes("unit_name")) {
          errMsg += "\r\n- Location";
        }
        if (!headers.includes("room_name")) {
          errMsg += "\r\n- Sensor Name";
        }
        if (!headers.includes("facility_external_id")) {
          errMsg += "\r\n- First Name";
        }
        if (!headers.includes("unit_external_id")) {
          errMsg += "\r\n- Last Name";
        }
        if (!headers.includes("room_external_id")) {
          errMsg += "\r\n- Email";
        }
        if (errMsg.length > 0) {
          this.importLoadingMessage = errMsg;
          return false;
        }
        return true;
      } else {
        this.importLoadingMessage =
          "Invalid File Headers! Please check the requirements";
        return false;
      }
    },
    csvArrayToJSON(headers, data) {
      if (headers && data) {
        var obj = {};
        for (var hIdx in headers) {
          var key = headers[hIdx].trim();
          if (key && key.length > 0) {
            obj[key] = data.length - 1 < hIdx ? null : data[hIdx];
          }
        }
        return obj;
      }
      return false;
    },
    CSVtoArray(text) {
      var re_valid =
        /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
      //var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
      var re_value =
        /(?!\s*$)\s*(?:"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,"\s\\]*(?:\s+[^,"\s\\]+)*))\s*(?:,|$)/g;
      // Return NULL if input string is not well formed CSV string.
      if (!re_valid.test(text)) {
        if (!re_value.test(text)) {
          return null;
        }
      }

      var a = []; // Initialize array to receive values.
      text.replace(
        re_value, // "Walk" the string using replace with callback.
        function (m0, m1, m2, m3) {
          // Remove backslash from \' in single quoted values.
          if (m1 !== undefined) a.push(m1.replace(/\\"/g, "\"").trim());
          // Remove backslash from \" in double quoted values.
          else if (m2 !== undefined) a.push(m2.replace(/\\"/g, "\"").trim());
          else if (m3 !== undefined) a.push(m3.trim());
          return ""; // Return empty string.
        }
      );
      // Handle special case of empty last value.
      if (/,\s*$/.test(text)) a.push("");
      return a;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async updateActiveFeaturesFlag() {
      const claims = await this.$auth.getIdTokenClaims();
      const userPermissions = claims["https://care.ai/permissions"];
      if (
        userPermissions &&
        userPermissions.length > 0 &&
        userPermissions.indexOf("update:locationActiveFeatures") > -1
      ) {
        this.updateActiveFeatures = true;
      } else {
        this.updateActiveFeatures = false;
      }
    },
    onActiveFeaturesCheckChange(activeFeatures, event) {
      activeFeatures["isEnable"] = event.target.checked;
      activeFeatures["isActive"] = event.target.checked;
    },
    onTempChange(event) {
      let thresholdValue = parseFloat(event.target.value);
      if (this.isUpdate) {
        this.selectedFacility.activeFeatures.find(
          (e) => e.typeFilter == "AREAS_ENTRANCE"
        )["temperature"] = parseFloat(event.target.value);
      } else {
        this.activeFeatures.find((e) => e.typeFilter == "AREAS_ENTRANCE")[
          "temperature"
        ] = parseFloat(event.target.value);
      }
    },
   
    saveLocation() {
      var sTimeZone = this.timeZone.filter(
        (e) => e.id == this.locationObject.timeZoneText
      )[0];
      if (sTimeZone) {
        this.locationObject["timezone"] = sTimeZone.id;
        this.locationObject["timezoneWithCity"] = sTimeZone.city;
      }
      this.locationObject.activeFeatures = this.isUpdate
        ? this.selectedFacility.activeFeatures
        : this.activeFeatures;

      let body = {
        location: {
          locationId: this.isUpdate == false ? "" : this.selectedLocationID,
          name: this.locationObject.name,
          isActive: this.locationObject.isActive,
          enableScheduling: this.locationObject.enableScheduling,
          timezone: this.locationObject.timezone,
          timezoneWithCity: this.locationObject.timezoneWithCity,
          unitMeasurements: this.locationObject.unitMeasurements,
          activeFeatures: this.locationObject.activeFeatures,
          // allowed_tv_config:this.locationObject.allowed_tv_config,
          // tvExternalID:this.locationObject.tvExternalID,
          units: [],
          settings: {
            virtualBackgroundImageUrl: this.locationObject.virtualBackgroundImageUrl,
            integrationNotAvailable: this.locationObject.integrationNotAvailable,
            redirectParticipantToURL: this.locationObject.redirectParticipantToURL,
            deviceFacilityLogo: this.locationObject.deviceFacilityLogo,
            callerIdNameFormat: this.locationObject.callerIdNameFormat,
            mobileHeartbeatURL: this.locationObject.mobileHeartbeatURL,          
          }
        }
      };
      var externalObj = [];
      if (this.tags.length) {
        this.tags.forEach((item) => {
          externalObj.push({ externalId: item });
        });

      }
      body.location.externalIds = externalObj
      if (this.isUpdate == false) this.postLocationToTenant(body);
      else this.updateLocationToTenant(body);
    },
    async postLocationToTenant(body) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations`;
      var get_Location = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.postLocationToTenant(body);
        }
        var getLoc = await response.json();
        if (response.status != 200) {
          loader.hide();
          Vue.$toast.open({
            message: getLoc.error ? getLoc.error : "please try again",
            type: "error"
          });
          return;
        }
        this.locationList.push(getLoc);
        this.locationList = this.sortArrayByKey(this.locationList, "name");


        this.buildTreeControlMapping(this.locationList);
        this.selectedLocationID = getLoc.locationId;
        this.lastSelectedLocation = getLoc.locationId;
        if (this.locationList.find((e) => e.locationId == getLoc.locationId))
          this.selectedFacility = this.locationList.find(
            (e) => e.locationId == getLoc.locationId
          );
        // this.lastSelectedLocation = this.selectedFacility;
        Vue.$toast.open({ message: "Successfully Saved", type: "success" });
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async updateLocationToTenant(body) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/${this.selectedLocationID}`;
      var get_Location = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.updateLocationToTenant(body);
        }
        var getLoc = await response.json();
        if (response.status != 200) {
          loader.hide();
          Vue.$toast.open({
            message: getLoc.error ? getLoc.error : "please try again",
            type: "error"
          });
          return;
        }
        var externalIDs =
          body.location && body.location.externalIds
            ? body.location.externalIds
            : [];
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "name"
        ] = this.locationObject.name;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "text"
        ] = this.locationObject.name;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "isActive"
        ] = this.locationObject.isActive;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "enableScheduling"
        ] = this.locationObject.enableScheduling;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "timezone"
        ] = this.locationObject.timezone;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "timezoneWithCity"
        ] = this.locationObject.timezoneWithCity;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "activeFeatures"
        ] = this.locationObject.activeFeatures;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "unitMeasurements"
        ] = this.locationObject.unitMeasurements;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)[
          "externalIds"
        ] = externalIDs;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)["settings"]["virtualBackgroundImageUrl"] =
          this.locationObject.virtualBackgroundImageUrl;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)["settings"]["integrationNotAvailable"] =
          this.locationObject.integrationNotAvailable;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)["settings"]["deviceFacilityLogo"] =
          this.locationObject.deviceFacilityLogo;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)["settings"]["redirectParticipantToURL"] =
          this.locationObject.redirectParticipantToURL;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)["settings"]["callerIdNameFormat"] =
          this.locationObject.callerIdNameFormat;
        this.locationList.find((e) => e.locationId == this.selectedLocationID)["settings"]["mobileHeartBeatUrl"] =
          this.locationObject.mobileHeartbeatURL;

        Vue.$toast.open({ message: "Successfully Updated", type: "success" });
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    saveUnit() {
      let body = {
        unit: {
          id: this.isUnitUpdate == false ? "" : this.unitObject.id,
          name: this.unitObject.name,
          isActive: this.unitObject.isActive
        }
      };
      let externalObj = [];
      if (this.tags.length) {
        this.tags.forEach((e) => {
          externalObj.push(e);
        });
        body.unit.externalIds = externalObj;
      }

      if (this.isUnitUpdate == false) this.postUnitToLocation(body);
      else this.updateUnitToLocation(body);
    },
    async postUnitToLocation(body) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/${this.selectedLocationID}/units`;
      var get_Location = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.postUnitToLocation(body);
        }
        var getLoc = await response.json();
        if (response.status != 200) {
          loader.hide();
          Vue.$toast.open({
            message: getLoc.error ? getLoc.error : "please try again",
            type: "error"
          });
          return;
        }
        var customerData = this.locationList.find(
          (e) => e.locationId == this.selectedLocationID
        );
        if (customerData.units) {
          customerData.units.push(getLoc);
        } else {
          customerData["units"] = [];
          customerData.units.push(getLoc);
        }
        // this.selectedFacility = customerData;
        this.buildTreeControlMapping(this.locationList);
        if (
          this.locationList.find((e) => e.locationId == this.selectedLocationID)
        )
          this.selectedFacility = this.locationList.find(
            (e) => e.locationId == this.selectedLocationID
          );
        loader.hide();
        Vue.$toast.open({ message: "Successfully Saved", type: "success" });
        this.unitObject = {
          id: "",
          name: "",
          isActive: true
        };
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async updateUnitToLocation(body) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/${this.selectedLocationID}/units/${this.unitObject.id}`;
      var get_Location = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);

        if (response.status === 503) {
          return this.postUnitToLocation(body);
        }
        var getLoc = await response.json();
        if (response.status != 200) {
          loader.hide();
          Vue.$toast.open({
            message: getLoc.error ? getLoc.error : "please try again",
            type: "error"
          });
          return;
        }
        const customerData = this.locationList.find(
          (e) => e.locationId == this.selectedLocationID
        );
        const customerDataUnit = customerData.units.find(
          (e) => e.id == this.unitObject.id
        );
        var externalIDs =
          body.unit && body.unit.externalIds ? body.unit.externalIds : [];
        // this.assignTags({ externalIds: externalIDs });
        customerDataUnit["name"] = this.unitObject.name;
        customerDataUnit["isActive"] = this.unitObject.isActive;

        customerDataUnit["externalIds"] = externalIDs;

        this.buildTreeControlMapping(this.locationList);
        if (
          this.locationList.find((e) => e.locationId == this.selectedLocationID)
        )
          this.selectedFacility = this.locationList.find(
            (e) => e.locationId == this.selectedLocationID
          );
        loader.hide();
        Vue.$toast.open({ message: "Successfully Updated", type: "success" });
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    isUnitValid() {
      this.externalPattern();
      if (this.unitObject.name.trim().length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isAreaValid() {
      this.externalPattern();
      if (
        this.areaObject.name.trim().length > 0 &&
        this.areaObject.type.trim().length > 0 &&
        this.areaObject.typeFilter.trim().length > 0 &&
        this.validatePhoneNumberExtension(this.areaObject.bedsidePhone)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isLocationValid() {
      let thresholdValue = parseFloat(this.locationObject.threshold);
      this.externalPattern();
      if (
        this.locationObject.name.trim().length > 0 &&
        this.locationObject.timeZoneText.trim().length > 0 &&
        thresholdValue >= 90 &&
        thresholdValue <= 107
      ) {
        return true;
      } else {
        return false;
      }
    },
    saveArea() {
      let body = {
        area: {
          id: this.isAreaUpdate == false ? "" : this.areaObject.id,
          name: this.areaObject.name,
          type: this.areaObject.typeFilter,
          defaultRoomView: this.areaObject.type,
          settings: {
            isInMaintenance: this.areaObject.maintenanceMode,
            allowOrphanedTasks: this.areaObject.allowOrphanedTasks,
            deviceAreaLogo: this.areaObject.deviceAreaLogo,
            showRoundingTask: this.areaObject.showRoundingTask,
            bedsidePhone: this.areaObject.bedsidePhone
            // allowed_tv_config: this.areaObject.allowed_tv_config,

          },
          hasBeds: false,
          beds: [],
          externalIds: []
        }
      };

      if (this.areaObject.allowed_tv_config && this.areaObject.allowed_tv_config != "") {
        body["area"]["tv_settings"] = { type: this.areaObject.allowed_tv_config };
        if (this.areaObject.hasExternalID) {
          body["area"]["tv_settings"]["tvSettingExternalId"] = this.areaObject.tvExternalID;
        }
      }

      let externalObj = [];
      if (this.tags.length) {
        this.tags.forEach((e) => {
          externalObj.push(e);
        });
        body.area["externalIds"] = externalObj;
      }
      if (this.isAreaUpdate == false) this.postAreaToLocation(body);
      else this.updateAreaToLocation(body);
    },
    async postAreaToLocation(body) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/${this.selectedLocationID}/units/${this.areaObject.unitId}/areas`;
      var get_Location = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.postUnitToLocation(body);
        }
        var result = await response.json();
        if (response.status != 200) {
          Vue.$toast.open({
            message: result.error ? result.error : "please try again",
            type: "error"
          });
          loader.hide();
          return;
        }
        var customerData = this.locationList.find(
          (e) => e.locationId == this.selectedLocationID
        );
        var customerDataUnit = customerData.units.find(
          (e) => e.id == this.areaObject.unitId
        );
        if (customerDataUnit.areas) {
          customerDataUnit.areas.push(result);
        } else {
          customerDataUnit["areas"] = [];
          customerDataUnit.areas.push(result);
        }
        // this.selectedFacility = customerData;
        this.buildTreeControlMapping(this.locationList);
        if (
          this.locationList.find((e) => e.locationId == this.selectedLocationID)
        )
          this.selectedFacility = this.locationList.find(
            (e) => e.locationId == this.selectedLocationID
          );
        loader.hide();
        let poc = {
          location: this.lastSelectedLocation,
          unit: this.areaObject.unitId,
          area: result.id
        };
        // let body = { 'tv_settings': { type: this.areaObject.allowed_tv_config, externalId: this.areaObject.externalIDs }, 'deviceModel': 'AMS R2O' }
        // this.updatePointOfCareProperties(poc, body)
        Vue.$toast.open({ message: "Successfully Saved", type: "success" });
        this.areaObject = {
          id: "",
          name: "",
          type: "Ambient Monitoring",
          maintenanceMode: false,
          allowOrphanedTasks: false,
          showRoundingTask: false,
          allowed_tv_config: "",
          deviceAreaLogo: "",
          bedsidePhone: "",
          typeFilter: this.areaObject.typeFilter,
          unitId: this.areaObject.unitId
        };
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async updateAreaToLocation(body) {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/tenants/${this.lastSelectedTenant}/locations/${this.selectedLocationID}/units/${this.areaObject.unitId}/areas/${this.areaObject.id}`;
      var get_Location = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        body: JSON.stringify(body),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.postUnitToLocation(body);
        }

        var result = await response.json();
        if (response.status != 200) {
          Vue.$toast.open({
            message: result.error ? result.error : "please try again",
            type: "error"
          });
          loader.hide();
          return;
        }
        var customerData = this.locationList.find(
          (e) => e.locationId == this.selectedLocationID
        );
        var customerDataUnit = customerData.units.find(
          (e) => e.id == this.areaObject.unitId
        );
        customerDataUnit["isOpen"] = true;
        var customerDataRoom = customerDataUnit.areas.find(
          (e) => e.id == this.areaObject.id
        );
        var externalIDs =
          body.area && body.area.externalIds ? body.area.externalIds : [];
        this.assignTags({ externalIds: externalIDs });
        customerDataRoom["name"] = this.areaObject.name;
        customerDataRoom["defaultRoomView"] = this.areaObject.type;
        customerDataRoom["externalIds"] = externalIDs;
        if (customerDataRoom["settings"]) {
          customerDataRoom["settings"]["isInMaintenance"] =
            this.areaObject.maintenanceMode;
          customerDataRoom["settings"]["allowOrphanedTasks"] =
            this.areaObject.allowOrphanedTasks;
          customerDataRoom["settings"]["showRoundingTask"] =
            this.areaObject.showRoundingTask;
          // customerDataRoom["settings"]["allowed_tv_config"] =
          //   this.areaObject.allowed_tv_config;
          customerDataRoom["settings"]["deviceAreaLogo"] =
            this.areaObject.deviceAreaLogo;
          customerDataRoom["settings"]["bedsidePhone"] =
            this.areaObject.bedsidePhone;
        } else {
          customerDataRoom.settings = {};
          customerDataRoom["settings"]["isInMaintenance"] =
            this.areaObject.maintenanceMode;
          customerDataRoom["settings"]["allowOrphanedTasks"] =
            this.areaObject.allowOrphanedTasks;
          customerDataRoom["settings"]["showRoundingTask"] =
            this.areaObject.showRoundingTask;
          // customerDataRoom["settings"]["allowed_tv_config"] =
          //   this.areaObject.allowed_tv_config;
          customerDataRoom["settings"]["deviceAreaLogo"] =
            this.areaObject.deviceAreaLogo;
          customerDataRoom["settings"]["bedsidePhone"] =
            this.areaObject.bedsidePhone;
        }
        this.buildTreeControlMapping(this.locationList);
        if (
          this.locationList.find((e) => e.locationId == this.selectedLocationID)
        )
          this.selectedFacility = this.locationList.find(
            (e) => e.locationId == this.selectedLocationID
          );
        loader.hide();
        let poc = {
          location: this.lastSelectedLocation,
          unit: this.areaObject.unitId,
          area: this.areaObject.id
        };
        // let body = { 'tv_settings': { type: this.areaObject.allowed_tv_config, externalId: this.areaObject.externalIDs }, 'deviceModel': 'AMS R2O' }
        // this.updatePointOfCareProperties(poc, body)
        Vue.$toast.open({ message: "Successfully Updated", type: "success" });
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    validatePhoneNumberExtension(phoneNo) {
      if (phoneNo.trim().length > 0) {
        const pattern = /^(pbx:\+?\d{1,11},[0-9*,#]+|(\+?\d{1,3}[-\s\.]?)?\(?\d{3}\)?[-\s\.]?\d{3}[-\s\.]?\d{4,6})$/i;      
        return pattern.test(phoneNo);
      }
      else{
        return true;
      }
    }
  }
};
</script>
<style lang="scss">
body .dropdown.tenantsList .dropdown-input {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  min-width: auto;
}

.tagsInput .ti-input {
  border-radius: 5px;
  margin-top: 5px;
}
.tagsInput{
   background-color: #5C6BC0;
  color: #fff;
}
.externalIdClass .btn-outline-secondary{
  color: #fff;
  border: none;
}

.inputText {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 0 10px;
  height: 36px;
  color: rgb(117, 117, 117);
}

.inputText:focus {
  outline: none;
}

.inputSelect {
  height: 36px;
  padding: 0 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.filterIcon,
.col-sm-9.label img {
  cursor: pointer;
}

.filterWrapper .dropdown .dropdown-content {
  max-width: 228px;
  min-width: 228px;
  margin-top: 5px;
}
</style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
    url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
    url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

.pageHeaderTitle {
  padding-left: 15px !important;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: not-allowed !important;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

.inputError{
  border: 1px solid #f16161;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

.requiredItem::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

.requiredItem::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

.requiredItem:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

.requiredItem:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="date"]:focus,
select.form-control:focus,
textarea.form-control:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"].requiredItem:focus,
input[type="email"].requiredItem:focus,
input[type="search"].requiredItem:focus,
input[type="number"].requiredItem:focus,
input[type="password"].requiredItem:focus,
input[type="tel"].requiredItem:focus,
input[type="date"].requiredItem:focus,
select.form-control.requiredItem:focus,
textarea.form-control.requiredItem:focus,
textarea.requiredItem:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border-bottom: 1px solid #dc858b;
}

input[type="text"]:hover,
input[type="email"]:hover,
input[type="search"]:hover,
input[type="number"]:hover,
input[type="password"]:hover,
input[type="tel"]:hover,
input[type="date"]:hover,
select.form-control:hover,
textarea.form-control:hover {
  box-shadow: none;
  background: #fff;
  outline: none !important;
}

input[type="text"].requiredItem:hover,
input[type="email"].requiredItem:hover,
input[type="search"].requiredItem:hover,
input[type="number"].requiredItem:hover,
input[type="password"].requiredItem:hover,
input[type="tel"].requiredItem:hover,
input[type="date"].requiredItem:hover,
select.form-control.requiredItem:hover,
textarea.form-control.requiredItem:hover {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"]:hover::-webkit-input-placeholder,
input[type="email"]:hover::-webkit-input-placeholder,
input[type="search"]:hover::-webkit-input-placeholder,
input[type="number"]:hover::-webkit-input-placeholder,
input[type="password"]:hover::-webkit-input-placeholder,
input[type="tel"]:hover::-webkit-input-placeholder,
input[type="date"]:hover::-webkit-input-placeholder,
select.form-control:hover::-webkit-input-placeholder,
textarea.form-control:hover::-webkit-input-placeholder,
textarea:hover::-webkit-input-placeholder,
input[type="text"]:focus::-webkit-input-placeholder,
input[type="email"]:focus::-webkit-input-placeholder,
input[type="search"]:focus::-webkit-input-placeholder,
input[type="number"]:focus::-webkit-input-placeholder,
input[type="password"]:focus::-webkit-input-placeholder,
input[type="tel"]:focus::-webkit-input-placeholder,
input[type="date"]:focus::-webkit-input-placeholder,
select.form-control:focus::-webkit-input-placeholder,
textarea.form-control:focus::-webkit-input-placeholder,
textarea:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-webkit-input-placeholder,
input[type="email"].requiredItem:hover::-webkit-input-placeholder,
input[type="search"].requiredItem:hover::-webkit-input-placeholder,
input[type="number"].requiredItem:hover::-webkit-input-placeholder,
input[type="password"].requiredItem:hover::-webkit-input-placeholder,
input[type="tel"].requiredItem:hover::-webkit-input-placeholder,
input[type="date"].requiredItem:hover::-webkit-input-placeholder,
select.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.requiredItem:hover::-webkit-input-placeholder,
input[type="text"].requiredItem:focus::-webkit-input-placeholder,
input[type="email"].requiredItem:focus::-webkit-input-placeholder,
input[type="search"].requiredItem:focus::-webkit-input-placeholder,
input[type="number"].requiredItem:focus::-webkit-input-placeholder,
input[type="password"].requiredItem:focus::-webkit-input-placeholder,
input[type="tel"].requiredItem:focus::-webkit-input-placeholder,
input[type="date"].requiredItem:focus::-webkit-input-placeholder,
select.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.requiredItem:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

input[type="text"]:hover::-moz-placeholder,
input[type="email"]:hover::-moz-placeholder,
input[type="search"]:hover::-moz-placeholder,
input[type="number"]:hover::-moz-placeholder,
input[type="password"]:hover::-moz-placeholder,
input[type="tel"]:hover::-moz-placeholder,
input[type="date"]:hover::-moz-placeholder,
select.form-control:hover::-moz-placeholder,
textarea:hover::-moz-placeholder,
textarea.form-control:hover::-moz-placeholder,
input[type="text"]:focus::-moz-placeholder,
input[type="email"]:focus::-moz-placeholder,
input[type="search"]:focus::-moz-placeholder,
input[type="number"]:focus::-moz-placeholder,
input[type="password"]:focus::-moz-placeholder,
input[type="tel"]:focus::-moz-placeholder,
input[type="date"]:focus::-moz-placeholder,
select.form-control:focus::-moz-placeholder,
textarea.form-control:focus::-moz-placeholder,
textarea:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-moz-placeholder,
input[type="email"].requiredItem:hover::-moz-placeholder,
input[type="search"].requiredItem:hover::-moz-placeholder,
input[type="number"].requiredItem:hover::-moz-placeholder,
input[type="password"].requiredItem:hover::-moz-placeholder,
input[type="tel"].requiredItem:hover::-moz-placeholder,
input[type="date"].requiredItem:hover::-moz-placeholder,
select.form-control.requiredItem:hover::-moz-placeholder,
textarea.form-control.requiredItem:hover::-moz-placeholder,
input[type="text"].requiredItem:focus::-moz-placeholder,
input[type="email"].requiredItem:focus::-moz-placeholder,
input[type="search"].requiredItem:focus::-moz-placeholder,
input[type="number"].requiredItem:focus::-moz-placeholder,
input[type="password"].requiredItem:focus::-moz-placeholder,
input[type="tel"].requiredItem:focus::-moz-placeholder,
input[type="date"].requiredItem:focus::-moz-placeholder,
select.form-control.requiredItem:focus::-moz-placeholder,
textarea.form-control.requiredItem:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-ms-input-placeholder,
input[type="email"]:hover:-ms-input-placeholder,
input[type="search"]:hover:-ms-input-placeholder,
input[type="number"]:hover:-ms-input-placeholder,
input[type="password"]:hover:-ms-input-placeholder,
input[type="tel"]:hover:-ms-input-placeholder,
input[type="date"]:hover:-ms-input-placeholder,
select.form-control:hover:-ms-input-placeholder,
textarea.form-control:hover:-ms-input-placeholder,
input[type="text"]:focus:-ms-input-placeholder,
input[type="email"]:focus:-ms-input-placeholder,
input[type="search"]:focus:-ms-input-placeholder,
input[type="number"]:focus:-ms-input-placeholder,
input[type="password"]:focus:-ms-input-placeholder,
input[type="tel"]:focus:-ms-input-placeholder,
input[type="date"]:focus:-ms-input-placeholder,
select.form-control:focus:-ms-input-placeholder,
textarea.form-control:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-ms-input-placeholder,
input[type="email"].requiredItem:hover:-ms-input-placeholder,
input[type="search"].requiredItem:hover:-ms-input-placeholder,
input[type="number"].requiredItem:hover:-ms-input-placeholder,
input[type="password"].requiredItem:hover:-ms-input-placeholder,
input[type="tel"].requiredItem:hover:-ms-input-placeholder,
input[type="date"].requiredItem:hover:-ms-input-placeholder,
select.form-control.requiredItem:hover:-ms-input-placeholder,
textarea.form-control.requiredItem:hover:-ms-input-placeholder,
input[type="text"].requiredItem:focus:-ms-input-placeholder,
input[type="email"].requiredItem:focus:-ms-input-placeholder,
input[type="search"].requiredItem:focus:-ms-input-placeholder,
input[type="number"].requiredItem:focus:-ms-input-placeholder,
input[type="password"].requiredItem:focus:-ms-input-placeholder,
input[type="tel"].requiredItem:focus:-ms-input-placeholder,
input[type="date"].requiredItem:focus:-ms-input-placeholder,
select.form-control.requiredItem:focus:-ms-input-placeholder,
textarea.form-control.requiredItem:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-moz-placeholder,
input[type="email"]:hover:-moz-placeholder,
input[type="search"]:hover:-moz-placeholder,
input[type="number"]:hover:-moz-placeholder,
input[type="password"]:hover:-moz-placeholder,
input[type="tel"]:hover:-moz-placeholder,
input[type="date"]:hover:-moz-placeholder,
select.form-control:hover:-moz-placeholder,
textarea.form-control:hover:-moz-placeholder,
input[type="text"]:focus:-moz-placeholder,
input[type="email"]:focus:-moz-placeholder,
input[type="search"]:focus:-moz-placeholder,
input[type="number"]:focus:-moz-placeholder,
input[type="password"]:focus:-moz-placeholder,
input[type="tel"]:focus:-moz-placeholder,
input[type="date"]:focus:-moz-placeholder,
select.form-control:focus:-moz-placeholder,
textarea.form-control:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-moz-placeholder,
input[type="email"].requiredItem:hover:-moz-placeholder,
input[type="search"].requiredItem:hover:-moz-placeholder,
input[type="number"].requiredItem:hover:-moz-placeholder,
input[type="password"].requiredItem:hover:-moz-placeholder,
input[type="tel"].requiredItem:hover:-moz-placeholder,
input[type="date"].requiredItem:hover:-moz-placeholder,
select.form-control.requiredItem:hover:-moz-placeholder,
textarea.form-control.requiredItem:hover:-moz-placeholder,
input[type="text"].requiredItem:focus:-moz-placeholder,
input[type="email"].requiredItem:focus:-moz-placeholder,
input[type="search"].requiredItem:focus:-moz-placeholder,
input[type="number"].requiredItem:focus:-moz-placeholder,
input[type="password"].requiredItem:focus:-moz-placeholder,
input[type="tel"].requiredItem:focus:-moz-placeholder,
input[type="date"].requiredItem:focus:-moz-placeholder,
select.form-control.requiredItem:focus:-moz-placeholder,
textarea.form-control.requiredItem:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS Starts here */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 0;
  padding-right: 15px;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input~.checkmark {
  border: 1px solid #1dd8f6;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked~.checkmark {
  background-color: #1dd8f6;
  border: 1px solid #1dd8f6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #6a6a6a;
  padding: 0;
  text-decoration: none;
}

.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.tempInput {
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--vs-colors--lightest);
  border-radius: 5px;
  margin: 0 10px 0 0;
  color: rgb(117, 117, 117);
}

.tempInput:focus-visible,
.tempInput:focus {
  outline: none;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  background: #f2fdff;
}

.menuItemsWrapper {
  border-right: 1px solid #e5f0f2;
  padding-right: 40px !important;
  margin-right: 40px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  padding-left: 40px;
  position: relative;
  color: #6a6a6a;
}

.menuItem>a {
  color: #6a6a6a;
  text-decoration: none;
}

.menuItem:hover,
.menuItem.active {
  color: #1dd8f6;
  cursor: pointer;
}

.menuItem:hover>a,
.menuItem.active>a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.menuItem:after,
.menuItem:after {
  content: "";
  background: #f27778;
  height: 3px;
  width: 0;
  position: absolute;
  top: 49px;
  transition: 0.5s;
  opacity: 0;
}

.menuItem:hover:after,
.menuItem.active:after {
  width: calc(100% - 40px);
  opacity: 1;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics>span {
  position: relative;
  top: -1px;
  color: #6a6a6a;
  font-size: 19px;
  line-height: 1;
}

.dashboardBlocksWrapper {
  padding: 30px 15px;
  background: #f2fdff;
  border-bottom: 1px solid #e5f0f2;
}

.dashboardBlock {
  background: red;
  margin: 0 15px;
  padding: 30px;
  border-radius: 10px;
}

.dashboardIcon {
  float: left;
  margin-right: 20px;
}

.dashboardNumber {
  float: left;
  font-size: 45px;
  color: #fff;
  line-height: 1;
}

.dashboardNumber>span {
  font-size: 16px;
  display: block;
}

.dashboardBlock:first-child {
  background: rgb(0, 192, 255);
  background: linear-gradient(45deg,
      rgba(0, 192, 255, 1) 0%,
      rgba(0, 192, 255, 1) 35%,
      rgba(26, 102, 168, 1) 100%);
}

.dashboardBlock:nth-child(2) {
  background: rgb(0, 255, 169);
  background: linear-gradient(45deg,
      rgba(0, 255, 169, 1) 0%,
      rgba(13, 77, 255, 1) 100%);
}

.dashboardBlock:nth-child(3) {
  background: rgb(31, 201, 253);
  background: linear-gradient(45deg,
      rgba(31, 201, 253, 1) 0%,
      rgba(252, 0, 97, 1) 100%);
}

.dashboardBlock:nth-child(4) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:nth-child(5) {
  background: rgb(0, 255, 255);
  background: linear-gradient(45deg,
      rgba(0, 255, 255, 1) 0%,
      rgba(147, 39, 143, 1) 100%);
}

.dashboardBlock:nth-child(6) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:last-child {
  background: rgb(254, 193, 148);
  background: linear-gradient(45deg,
      rgba(254, 193, 148, 1) 0%,
      rgba(254, 168, 141, 1) 30%,
      rgba(254, 107, 125, 1) 50%,
      rgba(254, 8, 99, 1) 70%,
      rgba(255, 0, 97, 1) 100%);
}

.facilityInfoWrapper {
  overflow: auto;
  max-height: calc(100vh - 262px);
}

.facilityInfoRow {
  padding: 30px 15px 0 15px;
  background: #fff;
  width: 100%;
}

.facilityInfo {
  color: #6a6a6a;
  font-size: 14px;
  margin: 0 15px 30px 15px;
  border: 1px solid #e5f0f2;
  border-radius: 10px;
  padding: 0;
  max-width: calc((100vw / 7) - 35px);
  width: calc((100vw / 7) - 35px);
}

.facilityInfo .dashboardNumber {
  color: #1a80a8;
  padding: 0 25px;
  font-size: 55px;
}

.facilityName {
  background: #f2fdff;
  color: #1dd8f6;
  font-size: 16px;
  text-align: center;
  padding: 10px 5px;
  border-radius: 0 0 10px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.infoWrapper {
  padding: 10px 20px;
  border-left: 1px solid #e5f0f2;
}

.infoItem {
  display: flex;
  line-height: 20px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  min-width: 360px;
  max-width: 360px;
  border-radius: 5px;
  margin-left: 10px;
  align-items: center;
  text-overflow: ellipsis;
}

.locationDataWrap .filterWrapper {
  background: #fff;
  border: 1px solid #ebebeb;
  padding-left: 0px
}

.locationDataWrap ::v-deep .ui.search.dropdown .text {
  color: #6a6a6a;
}

.pageHeader .filterWrapper .dropdown:before {
  border: solid #fff;
  border-width: 0 1px 1px 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background: transparent !important;
}

.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #00b5da;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  color: #fff;
  padding: 0 15px;
  height: 40px;
}

.popupHead span {
  float: right;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #f2fdff;
  color: #6a6a6a;
  padding: 15px;
  justify-content: center;
  text-align: center;
}

.yesBtn,
.noBtn {
  margin-right: 15px;
  border: 1px solid #dae1f2 !important;
  border-radius: 10px;
  padding: 5px 20px !important;
}

.noBtn {
  margin-left: 15px;
  margin-right: 0px;
}

.yesBtn:hover,
.noBtn:hover {
  background: #fff !important;
  color: #00b5da !important;
}

.modal-header {
  background: #50b9d4;
  color: #fff;
}

.modal-title {
  font-size: 14px !important;
}

.modal-body {
  color: #7b7b7b;
}

.modal-footer {
  background: #f2fdff;
  color: #1a80a8;
  justify-content: center;
}

.modal-footer .btn {
  padding: 5px 20px;
  border-radius: 6px;
  min-width: 100px;
  //border: 1px solid #50B9D4 !important;
}

.modal-footer .btn:hover {
  background: #fff;
  color: #50b9d4;
  cursor: pointer;
}

.modal-footer> :not(:last-child) {
  margin-right: 15px;
}

.modal-footer> :not(:first-child) {
  margin-left: 15px;
}

.filter-wrapper-2 {
  max-width: 400px;
  min-height: 36px;
}

.filterText {
  color: #fff;
  opacity: 1;
  padding-right: 5px;
}

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent !important;
  height: auto;
}

.filterDropDown {
  color: #fff;
  opacity: 1;
  text-decoration: none;
  width: 100%;
  display: inline-block;
}

.filterDropDown:after {
  float: right;
  position: relative;
  top: 10px;
}

.filterDropDown:hover {
  text-decoration: none;
}

.filterDropDownData,
.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

.actionDropDownData {
  top: 10px !important;
}

.filterDropDownData>a,
.actionDropDownData>a {
  color: #6a6a6a;
  text-decoration: none;
  padding: 5px 15px;
  position: relative;
}

.filterDropDownData>a:hover,
.filterDropDownData>a.active,
.actionDropDownData>a:hover,
.actionDropDownData>a.active {
  text-decoration: none;
  background: #f2fdff;
  color: #1dd8f6;
}

.locTenantWrapper input {
  min-width: 230px;
  max-width: 230px;
}

.filterDropDownData>a::after,
.actionDropDownData>a::after {
  content: "";
  height: 1px;
  width: 70%;
  left: 15%;
  position: absolute;
  bottom: 0;
  background: #daf9ff;
}

.filterDropDownData>a:last-child::after,
.filterDropDownData>a.active::after,
.filterDropDownData>a:hover:after,
.actionDropDownData>a:last-child::after,
.actionDropDownData>a.active::after,
.actionDropDownData>a:hover:after {
  display: none;
}

.pageDataWrapper {
  padding: 20px;
}

.tableDataWrapper {}

.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}

.contentHeader td {
  padding: 0 15px;
}

.contentRow>td {
  border-bottom: 1px solid #daf9ff;
  align-items: center;
  padding: 0 15px;
  background: #fff !important;
  color: #6a6a6a;
  cursor: pointer;
}

.contentRow.error td {
  background: #f16161 !important;
  color: #fff;
}

.contentRow.active td {
  background-color: #f4fbfe !important;
}

.contentRow:hover td {
  background-color: #f4fbfe !important;
}

.contentRow.error:hover td {
  background-color: #f57676 !important;
}

.contentDataWrapper {
  overflow: auto;
  overflow-y: auto;
  max-height: calc(100vh - 270px);
  min-height: calc(100vh - 270px);
  align-content: flex-start;
}

.contentRow {
  height: 50px;
}

.contentData {
  background: #fff;
  color: #6a6a6a;
  height: auto;
  margin-top: 10px !important;
  cursor: pointer;
  min-height: 48px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData>div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}

.contentData>div:first-child {
  border-left: 0px solid;
}

.devicesPageHeader {
  padding-left: 0;
}

.deviceStatus {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  background: #66be6d;
}

.deviceStatus.offlineDevices {
  background: #f27778;
}

.deviceStatus.totalDevices {
  background: #3188D2;
}

.devicesPageHeader .filterWrapper {
  max-width: 200px;
  min-width: 200px;
}

.actionDropDown {
  background: #50b9d4;
  border-radius: 20px;
  color: #fff;
  float: right;
  padding: 5px 25px;
  width: 140px;
  text-align: left;
}

.actionDropDown:after {
  right: 30px;
  position: absolute;
  top: 15px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.contentData>div .actionDropDown {
  background: transparent;
  border: 1px solid #dedede;
  color: #6a6a6a;
}

.deviceName {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 5px !important;
  margin-bottom: 5px;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.deviceName>span {
  color: #50b9d4;
  padding-right: 15px;
}

.deviceDataWrapper .contentData {
  height: 80px;
}

.deviceDataWrapper .contentData>div:last-child {
  display: inline-flex;
  overflow: unset;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 0px 25px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 15px;
  width: auto;
  line-height: 36px;
  border: none;
  color: #fff;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background: #3288D2;
}

::v-deep .ti-input {
  border: 1px solid #ccc;
  display: flex;
  padding: 5px 0px;
  flex-wrap: wrap;
  border-radius: 5px;
  margin-top: 5px;
}
::v-deep .ti-tag {
    background-color: #5C6BC0;
    color: #fff;
    border-radius: 2px;
    display: flex;
    padding: 3px 5px;
    margin: 2px;
    font-size: .85em;
}
// ::v-deep  .ti-tag .ti-content{
//   display: flex;
//   align-items: center;
// }
// ::v-deep .ti-tags {
//     display: flex;
//     flex-wrap: wrap;
//     width: 100%;
//     line-height: 1em;
// }
// .ti-new-tag-input-wrapper {
//     display: flex;
//     flex: 1 0 auto;
//     padding: 3px 5px;
//     margin: 2px;
//     font-size: .85em;
// }
// .ti-new-tag-input-wrapper input {
//     flex: 1 0 auto;
//     min-width: 100px;
//     border: none;
//     padding: 0px;
//     margin: 0px;
// }

.hasNotifications {
  max-width: 160px;
}

.selectArea {
  max-width: 130px;
}

.userContentWrapper .contentData>div:first-child,
.userContentWrapper .contentData>div:nth-child(2) {
  display: flex;
}

.userContentWrapper .contentData>div span {
  color: #6a6a6a;
  padding-right: 5px;
}

.btn {
  background: #1dd8f6;

  color: #fff;
  // position:absolute;
  // top:250px;
  // left:500px;
  border-color: #1dd8f6;
  padding: 5px 10px;
  border: 0px;
}

.btn:hover {
  background: #3288D2;
}

.userDetailContentHeader {
  background: #ebebeb;
  color: #484848;
  font-size: 15px;
  padding: 15px 0;
  border-radius: 5px;
}

.userDetailContentHeader>div {
  display: inline-flex;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}

.buttonItem.disabled,
.buttonItem[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

a.buttonItem.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}

.buttonItem:hover {
  background: #3188D2;
  color: #fff;
  border: 1px solid #3288D2;
}

.buttonItem img {
  margin-left: 15px;
}

.detailWrapper {
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #a6e3f0;
  margin-top: 30px !important;
  max-height: calc(100vh - 300px);
  overflow: hidden;
  overflow-y: auto;
  min-height: 100px;
}

.userDemograpics {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #dceaea;
}

.h-100 {
  overflow-x: hidden;
}

.labelText {
  color: #1dd8f6;
}

.userDetails {
  width: 100%;
}

.userDetails .col:first-child {
  border-right: 1px solid #fdf7f7;
  padding-right: 20px;
}

.userDetails .col:last-child {
  padding-left: 20px;
}

.addBtn {
  border: 1px solid #dceaea !important;
  border-radius: 5px;
  padding: 7px 15px !important;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
  cursor: pointer;
}

.selectListItems {
  width: calc(100% - 120px);
  margin-right: 30px;
}

.selectedItem {
  color: #6a6a6a;
  margin-top: 30px;
}

.selectedItem>img {
  margin-right: 15px;
}

.clearSelectedItems {
  color: #f27778;
  text-decoration: underline;
  padding-top: 30px;
  width: 67px;
  cursor: pointer;
}

.locationDataWrap .row {
  border-top: 1px solid #ebebeb;
  padding-bottom: 15px;
  padding-top: 15px;
  border-right: 1px solid #ebebeb;
}

.locationDataWrap .row:last-child {
  border-bottom: 1px solid #ebebeb;
}

.locationDataWrap .col {
  border-left: 1px solid #ebebeb;
}

.locationDataWrap .col:first-child {
  border-left: none;
}

.locationDataWrap label {
  display: block;
  color: #333;
}

.leftTree {
  padding-top: 15px;
  padding-left: 0px;
  height: calc(100vh - 230px);
  overflow: hidden;
  overflow-y: auto;
  padding-right: 15px;
}

::v-deep .ui.selection.dropdown .menu .item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  // max-width: 334px;
  margin: 0px 10px 2px;
  padding: 10px 7px !important;
  border-radius: 5px;
  border: none;
}



.pageHeader ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text,
.pageHeader ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,
.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text {
  color: #fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,
::v-deep .ui.selection.active.dropdown {
  box-shadow: none;
}

::v-deep .ui.dropdown .menu>.item:hover {
  color: #1dd8f6;
  background: #EAF9FF !important;
}

::v-deep .ui.dropdown .menu>.item.selected {
  color: #1dd8f6;
  background: #fff;
}

@media (max-width: 1919px) {
  .dashboardBlock {
    padding: 15px;
  }

  .dashboardIcon {
    margin-right: 10px;
  }

  .dashboardIcon>img {
    width: 22px;
  }

  .dashboardNumber {
    font-size: 36px;
  }

  .dashboardNumber>span {
    font-size: 12px;
    display: block;
  }

  .facilityInfo .dashboardNumber {
    padding: 0 13px;
    font-size: 36px;
  }

  .facilityName {
    font-size: 14px;
  }

  .infoWrapper {
    padding: 10px;
  }

  .facilityInfoWrapper {
    overflow: auto;
    max-height: calc(100vh - 220px);
  }

  .pageHeader {
    font-size: 20px;
  }

  .actionDropDown {
    width: 125px;
  }

  .userContentWrapper .contentData>div:nth-child(2) .text-right {
    text-align: left !important;
  }

  .filterInputText {
    max-width: 215px !important;
    background: rgba(255, 255, 255, 0.5) !important;
    color: #fff !important;
    padding: 0 0 0 4px !important;
  }
}

.filterInputText {
  max-width: 215px !important;
  background: #575757 !important;
  outline: none !important;
  border: 1px solid #575757 !important;
  //background: rgba(255,255,255,0.5) !important;
  color: #fff !important;
  padding: 1px 15px;
  padding-left: 0 !important;
}

#tenantConnectionId option {
  color: #6a6a6a;
}

.subHeadWrap {
  line-height: 35px;
  padding: 0 32px 0px 5px;
}

body select {
  /*width: 100px !important;*/
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  outline: none;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  // background: rgba(0, 0, 0, 0.3);
  color: #6a6a6a;
}

.v-toast__item .toast-bgclass {
  background-color: #f16161 !important;
}

.contacts {
  overflow: hidden;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filterWrapperEdit {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .ui.search.dropdown .text {
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 15px;
  color: #fff;
}



.virtualBackGroundImage {
  width: 600px;
}

.virtualBackgroundDIV {
  align-items: center;
}

.virtualBackgroundUploadDIV {
  padding-top: 10px;
}
</style>
